export const styles = (theme) => ({
  drawer: {
    width: 220,
    flexShrink: 0,
    backgroundColor: "#F3F3F3"
  },
  drawerPaper: {
    width: 220,
    borderRight:0,
    backgroundColor: "#F3F3F3"
  },
  menuItem: {
    color: "#404040",
    fontFamily: "Source Sans Pro,sans-serif",
    fontSize: "13px",
    background: "none",
    lineHeight: 1.25,
    padding: "16px 24px",
    textDecoration: "none",
    wordBreak: "break-word",
    wordWrap: "break-word",
    fontWeight: 300,
  },
  menuItemActive: {
    background: "#ebecec",
    fontWeight: 700,
    boxShadow: "inset 4px 0 #e30613",
  },
});
